module.exports = __webpack_public_path__ + "img/Forget password_progress bar3.653178b3.png";